/** Mirrors `Backoffice::User#manage_section?`. Do not use `manageCommittees` or `manageableSections`. */
export function canManageSectionCommittee({
  isGlobalAdmin,
  assignedSectionLegacyIds,
  sectionLegacyId
}: {
  isGlobalAdmin: boolean;
  assignedSectionLegacyIds: readonly string[];
  sectionLegacyId?: string | null;
}): boolean {
  if (isGlobalAdmin) return true;
  if (!sectionLegacyId) return false;
  return assignedSectionLegacyIds.includes(sectionLegacyId);
}

export function canManageAnySectionCommittee({
  isGlobalAdmin,
  assignedSectionLegacyIds
}: {
  isGlobalAdmin: boolean;
  assignedSectionLegacyIds: readonly string[];
}): boolean {
  return isGlobalAdmin || assignedSectionLegacyIds.length > 0;
}
